import React, { FunctionComponent } from "react";
import styles from "./CustomButton.module.css";
import Loading from "../../Loading/Loading";

type CustomButtonProps = {
  text: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void; // Correctly typed event
  buttonType?: "primary" | "secondary" | "inactive"; // Optional prop with default
  customStyling?: React.CSSProperties; // Proper type for inline styles
  buttonDisable?:any;
};

const CustomButton: FunctionComponent<CustomButtonProps> = ({
  text,
  onClick,
  buttonType = "primary", // Default button type
  customStyling = {}, // Default inline styles
  buttonDisable
}) => {
  const className =
    buttonType === "primary"
      ? styles.btnPrimary
      : buttonType === "secondary"
      ? styles.btnSecondary
      : styles.btnInactive;

  return (
    <button
      className={className}
      style={customStyling}
      onClick={onClick}
      disabled={buttonDisable?buttonDisable:false}
    >
      {text}
    </button>
  );
};

export default CustomButton;
